import React, { useState } from 'react';
import { base44 } from '@/api/base44Client';

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState('idle');

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return;
    setStatus('loading');
    try {
      await base44.entities.NewsletterSubscriber.create({ email: email.trim(), consent: true, source_page: window.location.pathname });
      base44.analytics.track({ eventName: 'newsletter_signup' });
      setStatus('done');
    } catch {
      setStatus('error');
    }
  };

  return (
    <section aria-labelledby="newsletter-heading" className="px-[6vw] py-[80px] bg-warm-black text-cream">
      <div className="max-w-editorial mx-auto text-center">
        <h2 id="newsletter-heading" className="font-serif mb-4">Οι νέες τάσεις, <em className="text-gold-light">πρώτα σε εσάς.</em></h2>
        <p className="text-cream/80 mb-8">Εγγραφείτε στο newsletter και λάβετε τις τελευταίες τάσεις και συμβουλές περιποίησης μαλλιών από τον Θοδωρή Οικονομάκη.</p>
        {status === 'done' ? (
          <p className="text-gold-light font-medium">Ευχαριστούμε! Η εγγραφή σας ολοκληρώθηκε.</p>
        ) : (
          <form onSubmit={submit} className="flex flex-col gap-4 max-w-[520px] mx-auto">
            <div className="flex flex-col sm:flex-row gap-3">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Το email σας" aria-label="Email"
                className="flex-1 min-h-[48px] px-5 rounded-pill bg-cream-bg text-warm-black" />
              <button type="submit" disabled={status === 'loading' || !consent}
                className="min-h-[48px] px-7 rounded-pill bg-gold-bg text-warm-black font-medium disabled:opacity-60">
                {status === 'loading' ? 'Εγγραφή…' : 'Εγγραφή'}
              </button>
            </div>
            <label className="flex items-start gap-2 text-left text-body-s text-cream/80">
              <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-1" />
              Συμφωνώ να λαμβάνω email από το Ikonomakis Hair Atelier. Μπορώ να διαγραφώ οποιαδήποτε στιγμή.
            </label>
            {status === 'error' && <p className="text-gold-light">Κάτι πήγε στραβά. Δοκιμάστε ξανά.</p>}
          </form>
        )}
      </div>
    </section>
  );
}